import React from "react";
import classNames from "classnames";
import { Link } from "@/components/Link";
import { Lazy } from "@/components/Lazy";
import { checkValidURL } from "@/utils/formHelper";
import { optimizeCloudinaryImage } from "@/services/CloudinaryService";
import "./SharedLinkCard.scss";

export interface SharedLinkCardProps {
  /** Text to display on the link */
  text: string;
  /** Destination URL */
  url: string;
  /** Optional image URL to display alongside the text */
  imageUrl?: string;
  /** Background color for the card */
  buttonColor?: string;
  /** Additional CSS class */
  className?: string;
}

export function SharedLinkCard({
  text,
  url,
  imageUrl,
  buttonColor,
  className,
}: SharedLinkCardProps) {
  const validUrl = checkValidURL(url) || "";

  return (
    <Link
      externalLink
      type="button"
      className={classNames("shared-link-card", className)}
      href={validUrl}
      style={{ backgroundColor: buttonColor }}
      prefetch={false}
    >
      {imageUrl && (
        <Lazy placeholderClass="shared-link-card__img-placeholder">
          <img
            className="shared-link-card__img"
            src={optimizeCloudinaryImage({
              url: imageUrl,
            })}
            alt={text}
          />
        </Lazy>
      )}
      <span className="shared-link-card__text">{text}</span>
    </Link>
  );
}
